import { Component, inject, input } from '@angular/core';
import { IonicModule, IonNav, ModalController } from '@ionic/angular';
import {
  SscButtonComponent,
  SscButtonHierarchy,
  SscButtonSize,
  SscIconComponent,
  SscIconHierarchy,
} from '@marineform/ssc-ui';
import { TranslocoPipe } from '@ngneat/transloco';
import { ModuleAction } from '@marineform/manage-data-access';
import { ModuleActionsComponent } from '@marineform/manage-ui';

@Component({
  selector: 'app-record-menu-root',
  template: `
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <button
            (click)="close()"
            ssc-button
            [size]="buttonSize.small"
            [hierarchy]="buttonHierarchy.inverted">
            <ssc-icon
              small
              [hierarchy]="iconHierarchy.basic"
              [svg]="'x'" />
          </button>
        </ion-buttons>
        <ion-title size="large">{{ title() | transloco }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding mg-padded" [fullscreen]="true">
      <app-module-actions [nav]="nav()" [actions]="actions()" />
    </ion-content>
  `,
  imports: [
    IonicModule,
    SscButtonComponent,
    SscIconComponent,
    TranslocoPipe,
    ModuleActionsComponent,
  ],
})
export class RecordMenuRootComponent {
  nav = input.required<IonNav>();
  actions = input<ModuleAction[]>([]);
  title = input<string>('record|menu|title');
  #modalController = inject(ModalController);
  buttonHierarchy = SscButtonHierarchy;
  buttonSize = SscButtonSize;
  iconHierarchy = SscIconHierarchy;
  close() {
    this.#modalController.getTop().then((modal) => {
      modal?.dismiss();
    });
  }
}
